module.exports = __webpack_public_path__ + "img/10.cfd5aea3.png";